export type Auth = {
	ltpaToken: string;
	passwordweak: boolean;
	groups: string[];
	correlationId: string;
	isCorpUser?: boolean;
	loginCode?: string;
};

const model: types.models.InputModel = {
	ltpaToken: 'response.LTPAToken',
	groups: 'response.groups',
	passwordweak: 'response.passwordweak',
	correlationId: 'response.correlationId',
	loginCode: 'response.loginCode',
	isCorpUser: 'response.isCorpUser',
};

export default model;
